import React, { useState } from "react";
import { Alert, Badge, Button, Card, Input, Tooltip } from "antd";
import TextArea from "antd/es/input/TextArea";
import { toast } from "react-toastify";
import { Box, CircularProgress } from "@mui/material";
import { Method_POST } from "../../../../../../../service/api";
import { FaRegEdit } from "react-icons/fa";
import { MdAdd } from "react-icons/md";


export function EditarObservacao({info, setInfo, fetchData, numeroSolicitacao, setIsModalEditarObservacao}) {
  
  const [loading, setLoading] = useState(false);
  const [descricaoObservacao, setDescricaoObservacao] = useState("");
  const [editandoIndex, setEditandoIndex] = useState(null);
  const [novaDescricao, setNovaDescricao] = useState('');
  const [isAddNovaObservacao, setIsAddNovaObservacao] = useState(false);
  
  const formatarData = () => {
    const data = new Date();
    const dia = String(data.getDate()).padStart(2, '0');
    const mes = String(data.getMonth() + 1).padStart(2, '0');
    const ano = data.getFullYear();
    return `${dia}/${mes}/${ano}`;
  };
  
  const contarObservacoes = (texto) => {
    if (!texto) return 0; // evita erro quando for null ou undefined
    return (texto.match(/Observação \d{2}/g) || []).length;
  };
  
  const editar = async () => {
    setLoading(true);
    if (!descricaoObservacao.trim()) {
      toast.warning("Digite uma observação antes de salvar!");
      setLoading(false);
      return;
    }
    try {
      const dataAtual = formatarData();
      const totalObservacoes = contarObservacoes(info.observacao || "");
      const numero = String(totalObservacoes + 1).padStart(2, '0'); // 01, 02...
  
      const novaObservacao = `Observação ${numero} - ${dataAtual}\n${descricaoObservacao}`;
  
      const textoFinal = info.observacao
        ? `${info.observacao}\n\n${novaObservacao}`
        : novaObservacao;
  
      const url = `/ordem-servico/observacao/atualizar`;
      const data = {
        id: numeroSolicitacao,
        observacao: textoFinal,
      };

      console.log("data", data);
  
      const responseData = await Method_POST(url, data);
  
      if (responseData) {
        setIsModalEditarObservacao(false);
        fetchData();
        toast.success("Observação adicionada com sucesso!");
        setDescricaoObservacao(""); // limpa o campo
      } else {
        throw new Error("Erro ao tentar editar observação");
      }
    } catch (error) {
      toast.error(error.message);
    } finally {
      setLoading(false);
    }
  };

  const formatarObservacoes = (texto) => {
    if (!texto) return { formatadas: [], naoFormatadas: [] };

    const regex = /(Observação \d{2} - \d{2}\/\d{2}\/\d{4})\n([^\n]+)/g;
    const matches = [...texto.matchAll(regex)];

    const formatadas = matches.map((match, index) => ({
      titulo: match[1],
      descricao: match[2],
      indexOriginal: index,
    }));

    // Remove as partes já capturadas do texto original
    let textoLimpo = texto;
    matches.forEach((match) => {
      textoLimpo = textoLimpo.replace(match[0], "");
    });

    const naoFormatadas = textoLimpo
      .split("\n")
      .map(linha => linha.trim())
      .filter(linha => linha); // remove linhas vazias

    return { formatadas, naoFormatadas };
  };

  const salvarEdicao = async (indexParaEditar) => {
    const resultado = formatarObservacoes(info.observacao);
    // CORREÇÃO: Usar resultado.formatadas e fazer uma cópia antes de reverter.
    const listaParaReconstruir = [...(resultado.formatadas || [])].reverse();

    // Edita a descrição no índice correto do array invertido (que é o que está sendo exibido)
    listaParaReconstruir[indexParaEditar].descricao = novaDescricao;
    // 2. Monta o texto formatado atualizado
    const textoFormatadoAtualizado = listaParaReconstruir
      .map(obs => `${obs.titulo}\n${obs.descricao}`)
      .join('\n\n');

    // 3. Pega o texto não formatado original
    const textoNaoFormatadoOriginal = resultado.naoFormatadas.join('\n');
    // 4. Combina os dois blocos
    let novoTexto = textoNaoFormatadoOriginal.trim();

    if (novoTexto && textoFormatadoAtualizado.trim()) {
      novoTexto += '\n\n'; // Adiciona separador
    }

    novoTexto += textoFormatadoAtualizado;

    novoTexto = novoTexto.trim();

    if (!novoTexto) {
      toast.warning("Conteúdo de observação vazio após edição.");
      setLoading(false);
      return;
    }

    try {
      setLoading(true);
      const url = `/ordem-servico/observacao/atualizar`;
      const data = {
        id: numeroSolicitacao,
        observacao: novoTexto,
      };
      const response = await Method_POST(url, data);
      if (response) {
        setInfo(prev => ({
          ...prev,
          observacao: novoTexto,
        }));

        toast.success("Descrição atualizada com sucesso!");
        setEditandoIndex(null);
        setNovaDescricao('');
        fetchData();
      } else {
        throw new Error("Erro ao tentar atualizar observação");
      }
    } catch (error) {
      toast.error(error.message);
    } finally {
      setLoading(false);
    }
  };
  
  const { formatadas, naoFormatadas } = formatarObservacoes(info.observacao);
  const observacoesFormatadas = formatadas.reverse();
  const observacoesNaoFormatadas = naoFormatadas.reverse();

  return (
    <>
      <div className="padding-10-container">
        <Alert message={<><strong>Instrução</strong><p>Edite e salve informações relevantes relacionadas à ordem de serviço.</p></>} />
          
        {loading ? (
          <div className="margin-0-auto">
            <Box sx={{ display: "flex" }}>
              <CircularProgress />
            </Box>
          </div>
        ) : (

            <>
              <div style={{ padding: 8 }}>
                {isAddNovaObservacao ? (
                  <>
                    <div style={{ marginBottom: 10 }}>
                      <Input
                        value={descricaoObservacao}
                        onChange={(e) => setDescricaoObservacao(e.target.value)}
                        placeholder="Digite sua observação aqui..."
                      /></div>

                    <div style={{ textAlign: "right" }}>
                       <Button className="bg-color" style={{marginRight: 5}} onClick={editar}>
                        Salvar
                      </Button>
                      <Button className="bg-color" onClick={()=> setIsAddNovaObservacao(false)}>
                        Cancelar
                      </Button>
                    </div></>
                ) : (
                  <>
                    <div style={{ textAlign: "left", justifyContent: "right", display: "flex", position: "relative", right: 10}}>
                      <div
                        onClick={()=> setIsAddNovaObservacao(true)}
                        style={{
                          width: "20px",
                          height: "20px",
                          padding: "10px",
                          borderRadius: "50%",
                          boxShadow: "rgba(0, 0, 0, 0.24) 0px 3px 8px",
                          fontSize: "25px",
                          cursor: "pointer",
                          display: "flex",
                          justifyContent: "center",
                          textAlign: "center",
                          alignItems: "center",
                          background: "#0361a7",
                          color: "#fff",
                          margin: "5px",
                        }}
                      >
                      <MdAdd />
                    </div>
                    </div>

                  </>
                )}
              </div>

              <div className="scroll-Y">
                {observacoesFormatadas.map((obs, index) => {
                  const estaEditando = editandoIndex === index;

                  return (
                    <div key={index} className="table-obs" style={{ marginBottom: '16px' }}>
                      {/* prefixo fixo */}
                      <Badge.Ribbon text={obs.titulo.split(" - ")[0]} style={{background: "rgb(3, 97, 167)", fontWeight: 500}}>
                        <Card title={obs.titulo.split(" - ")[1]} size="small">
                          {estaEditando ? (
                            <>
                              {/* parte editável */}
                              <div className="margin-btn">
                                <Input
                                  value={novaDescricao}
                                  onChange={(e) => setNovaDescricao(e.target.value)}
                                  placeholder="Digite sua observação..."
                                />
                              </div>
                              <Button
                                className="bg-color"
                                onClick={() => salvarEdicao(index)}
                                style={{ marginRight: 5 }}
                              >
                                Salvar
                              </Button>
                              <Button onClick={() => setEditandoIndex(null)}>Cancelar</Button>
                            </>
                          ) : (
                            <>
                              <div className="margin-btn observacao">
                                <span>{obs.descricao}</span>
                              </div>
                              <div style={{textAlign: "right", justifyContent: "right", display: "flex"}}>
                                  <Tooltip title="Editar observação">
                                    <div
                                    style={{
                                      width: "20px",
                                      height: "20px",
                                      padding: "10px",
                                      borderRadius: "50%",
                                      boxShadow: "rgba(0, 0, 0, 0.24) 0px 3px 8px",
                                      fontSize: "20px",
                                      cursor: "pointer",
                                      display: "flex",
                                      justifyContent: "center",
                                      textAlign: "center",
                                      alignItems: "center",
                                      background: "#faad14",
                                      color: "#fff",
                                      margin: "5px",
                                    }}

                                    onClick={() => {
                                      setEditandoIndex(index);
                                      setNovaDescricao(obs.descricao);
                                    }}
                                  >
                                    <FaRegEdit />
                                </div>
                                  </Tooltip>
                              </div>
                            </>
                          )}
                        </Card>
                      </Badge.Ribbon>
                    </div>
                  );
                })}

                {observacoesNaoFormatadas.length > 0 && (
                  <div style={{ marginTop: 24 }}>
                    {observacoesNaoFormatadas.map((obs, index) => (
                      <div
                        key={index}
                        className="outras-obs"
                      >
                        <strong style={{ color: '#856404' }}>Observação não formatada:</strong>
                        <div style={{ marginTop: '6px', color: '#856404' }}>{obs}</div>
                      </div>
                    ))}
                  </div>
                )}
              </div>
            </>
        )}
      </div>
    </>
  );
}

export default EditarObservacao;
